import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail, ScrollText } from "lucide-react";

// Static Terms of Use page. Not legal advice — placeholder scaffolding so footer
// "Terms" link no longer 404s. Product team can swap in the reviewed copy anytime.

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-12" data-testid="page-terms">
      <div className="flex items-center gap-2 mb-2">
        <ScrollText className="text-[#E05E36]" size={22} />
        <div className="text-[10px] uppercase tracking-widest font-black text-stone-500">Legal</div>
      </div>
      <h1 className="heading text-3xl md:text-4xl font-extrabold text-stone-900">Terms of Use</h1>
      <div className="text-sm text-stone-500 mt-1">Last updated: February 2026</div>

      <div className="mt-8 space-y-6 text-stone-700 leading-relaxed">
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">1. Acceptance</h2>
          <p>By using find2near.com or the Find2Near app ("Service") you agree to these Terms. If you don't agree, please don't use the Service.</p>
        </section>
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">2. Marketplace only</h2>
          <p>Find2Near is a discovery platform that connects neighbours with local providers, sellers and services. We are not a party to transactions between users. Payments made on the Service are governed by the payment provider's own terms.</p>
        </section>
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">3. Listings & KYC</h2>
          <p>Sellers agree that all listing content is truthful. Some categories — 18+, matrimonial, dating, gold trading — require verified identity (KYC). Fraudulent listings will be removed and the account may be suspended.</p>
        </section>
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">4. Prohibited items</h2>
          <p>You may not list: firearms, controlled/prescription drugs, live animals, stolen property, counterfeit goods, sexually explicit content, gambling services, or anything else restricted by Indian law.</p>
        </section>
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">5. Liability</h2>
          <p>The Service is provided "as-is." Find2Near disclaims all warranties and is not liable for losses arising from marketplace transactions between users.</p>
        </section>
        <section>
          <h2 className="heading font-bold text-lg text-stone-900 mb-1">6. Contact</h2>
          <p>Questions? Reach us at <a className="text-[#E05E36] font-semibold" href="mailto:hello@find2near.com">hello@find2near.com</a> or visit the <Link to="/contact" className="text-[#E05E36] font-semibold">Contact page</Link>.</p>
        </section>
      </div>
    </div>
  );
}
